import { type Config, type DriveStep } from 'driver.js';

type DriverJsConfig = {
  steps: DriveStep[];
  onDestroyed?: () => void;
};

export const driverJsConfig: (options: DriverJsConfig) => Config = (options: DriverJsConfig) => {
  return {
    smoothScroll: true,
    allowClose: true,
    // Several steps ask the user to actually operate the UI (open a dropdown,
    // pick a patient). Any click that misses the highlighted element lands on
    // the overlay, and the default `'close'` would tear the tour down mid-task.
    // A no-op keeps it alive; the ✕ button and Escape still close it.
    overlayClickBehavior: () => {},
    prevBtnText: '← Zurück',
    nextBtnText: 'Weiter →',
    showProgress: true,
    onDestroyed: options.onDestroyed,
    steps: options.steps,
  };
};
